module.exports = __webpack_public_path__ + "img/entry.a44184f8.svg";